import {ValueDefinition} from '@/model/types';

export enum ParticipantOrExSpouse {
  PARTICIPANT = 'DV-12#0',
  EX_SPOUSE = 'DV-12#1',
}

export const DV_12 = {
  id: 'DV-12',
  description: {
    fr: 'Participant ou ex-conjoint',
    en: 'Participant or ex-spouse',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Participant ou ancien participant (régime de retraite)',
        en: 'Member or former member (pension plan)',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Ex-conjoint du participant à la suite d’une rupture de mariage ou d’un décès',
        en: 'Ex spouse following death or marriage breakdown',
      },
    },
  ],
} as const satisfies ValueDefinition;
